import { render } from "./QualibotChat.vue?vue&type=template&id=dbfae7b0&scoped=true"
import script from "./QualibotChat.vue?vue&type=script&lang=js"
export * from "./QualibotChat.vue?vue&type=script&lang=js"

import "./QualibotChat.vue?vue&type=style&index=0&id=dbfae7b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbfae7b0"]])

export default __exports__